import COLORS from './universal.color';

const {
  mlbBlack,
  mlbWhite,
  mlbGrey1,
  mlbGrey2,
  mlbGrey3,
  mlbGrey4,
  mlbGrey5,
  mlbGrey6,
  mlbGrey7,
  linkBlue,
  ticketGreen,
  mlbTvOrange,
  linkBlueHover,
  ticketGreenHover,
  mlbTvOrangeHover,
  linkBlueOnDark,
  linkBlueOnDarkHover,
  transparent,
} = COLORS;

export const ComponentColorsHollowLight = {
  disabled: {
    color: mlbGrey3,
    borderColor: mlbGrey2,
    backgroundColor: mlbGrey1,
  },
  default: {
    color: mlbGrey7,
    borderColor: mlbGrey2,
    backgroundColor: transparent,
    hoverBorderColor: mlbGrey4,
  },
  grey: {
    color: mlbGrey5,
    borderColor: mlbGrey5,
    backgroundColor: transparent,
    hoverBackgroundColor: mlbGrey5,
    hoverColor: mlbWhite,
  },
  linkBlue: {
    color: linkBlue,
    borderColor: linkBlue,
    backgroundColor: transparent,
    hoverBackgroundColor: linkBlue,
    hoverColor: mlbWhite,
  },
  ticketGreen: {
    color: ticketGreen,
    borderColor: ticketGreen,
    backgroundColor: transparent,
    hoverBackgroundColor: ticketGreen,
    hoverColor: mlbWhite,
  },
  mlbTvOrange: {
    color: mlbTvOrange,
    borderColor: mlbTvOrange,
    backgroundColor: transparent,
    hoverBackgroundColor: mlbTvOrange,
    hoverColor: mlbWhite,
  },
  linkBlueOnDark: {
    color: mlbWhite,
    backgroundColor: linkBlueOnDark,
    hoverBackgroundColor: linkBlueOnDarkHover,
  },
};

export const ComponentColorsSolidLight = {
  disabled: {
    color: mlbWhite,
    backgroundColor: mlbGrey2,
  },
  default: {
    color: mlbGrey7,
    backgroundColor: mlbWhite,
    hoverBackgroundColor: mlbGrey1,
  },
  grey: {
    color: mlbWhite,
    backgroundColor: mlbGrey5,
    hoverBackgroundColor: mlbGrey2,
    hoverColor: mlbBlack,
  },
  linkBlue: {
    color: mlbWhite,
    backgroundColor: linkBlue,
    hoverBackgroundColor: linkBlueHover,
  },
  ticketGreen: {
    color: mlbWhite,
    backgroundColor: ticketGreen,
    hoverBackgroundColor: ticketGreenHover,
  },
  mlbTvOrange: {
    color: mlbWhite,
    backgroundColor: mlbTvOrange,
    hoverBackgroundColor: mlbTvOrangeHover,
  },
  linkBlueOnDark: {
    color: mlbWhite,
    backgroundColor: linkBlueOnDark,
    hoverBackgroundColor: linkBlueOnDarkHover,
  },
};

export const ComponentColorsHollowDark = {
  disabled: {
    color: mlbGrey6,
    borderColor: mlbGrey5,
    backgroundColor: transparent,
  },
  default: {
    color: mlbGrey1,
    borderColor: mlbGrey2,
    backgroundColor: transparent,
    hoverBackgroundColor: mlbGrey6,
  },
  grey: {
    color: mlbWhite,
    borderColor: mlbGrey2,
    backgroundColor: transparent,
    hoverBackgroundColor: mlbGrey2,
    hoverColor: mlbBlack,
  },
  linkBlue: {
    color: linkBlueOnDark,
    borderColor: linkBlueOnDark,
    backgroundColor: transparent,
    hoverBackgroundColor: mlbGrey7,
  },
  ticketGreen: {
    color: ticketGreen,
    borderColor: ticketGreen,
    backgroundColor: transparent,
    hoverBackgroundColor: mlbGrey7,
  },
  mlbTvOrange: {
    color: mlbTvOrange,
    borderColor: mlbTvOrange,
    backgroundColor: transparent,
    hoverBackgroundColor: mlbGrey7,
  },
  linkBlueOnDark: {
    color: mlbWhite,
    backgroundColor: linkBlueOnDark,
    hoverBackgroundColor: linkBlueOnDarkHover,
  },
};

export const ComponentColorsSolidDark = {
  disabled: {
    color: mlbGrey3,
    backgroundColor: mlbGrey5,
  },
  default: {
    color: mlbGrey7,
    backgroundColor: mlbWhite,
    hoverBackgroundColor: mlbGrey2,
  },
  grey: {
    color: mlbWhite,
    backgroundColor: mlbGrey5,
    hoverBackgroundColor: mlbWhite,
    hoverColor: mlbBlack,
  },
  linkBlue: {
    color: mlbWhite,
    backgroundColor: linkBlueOnDark,
    hoverBackgroundColor: linkBlueOnDarkHover,
  },
  ticketGreen: {
    color: mlbWhite,
    borderColor: ticketGreen,
    backgroundColor: ticketGreen,
  },
  mlbTvOrange: {
    color: mlbWhite,
    borderColor: mlbTvOrange,
    backgroundColor: mlbTvOrange,
  },
  linkBlueOnDark: {
    color: mlbWhite,
    backgroundColor: linkBlueOnDark,
    hoverBackgroundColor: linkBlueOnDarkHover,
  },
};

export const ComponentColors = {
  light: {
    hollow: ComponentColorsHollowLight,
    solid: ComponentColorsSolidLight,
  },
  dark: {
    hollow: ComponentColorsHollowDark,
    solid: ComponentColorsSolidDark,
  },
};
